import ClickOutside from 'v-click-outside';

export default {
  name: 'SettingsNav',
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  data() {
    return {
      backTo: null,
      settingsNavOpened: false,
    };
  },
  computed: {
    backLink() {
      return this.backTo ? { path: this.backTo } : { name: this.$route.params.merchant_id ? 'Chat' : 'BusinessList' };
    },
  },
  mounted() {
    this.backTo = this.$route.params.back_to;
  },
  methods: {
    hideSettingsNav() {
      this.settingsNavOpened = false;
    },
    toggleSettingsNav() {
      this.settingsNavOpened = !this.settingsNavOpened;
    },
  },
};
